































import { Component, Prop, Mixins } from 'vue-property-decorator'

import AppOrderItemList from '@/components/AppOrderItemList.vue'
import AppRouterLink from '@/components/AppRouterLink.vue'
import OrderItem from '@/components/OrderItem.vue'
import { CURRENT_USER } from '@/gql/auth'
import { Common } from '@/mixins'

@Component({
  components: {
    AppOrderItemList,
    AppRouterLink,
    OrderItem
  },
  apollo: {
    currentUser: {
      query: CURRENT_USER
    }
  }
})
export default class extends Mixins(Common) {
  currentUser = null
  @Prop() readonly order!: object
  @Prop() readonly orderDelivery!: object
  @Prop() readonly showActions!: boolean
}
